import React, { useEffect, useState } from "react";
import orderService from "../../services/orderService";
import CrudTable from "../../components/dashboard/table/CrudTable";
import DashboardWrapper from "../../components/DashboardWrapper";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import Breadcrumb from "../../components/Breadcrumbdashboard";

export default function AllOrders() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = [
    "sl",
    "invoice_id",
    "user_name",
    "city",
    "order_status",
    "payment_status",
    "payment_method",
    "product_qty",
    "amount",
    "order_date",
  ];

  const fetchOrders = async () => {
    try {
      const response = await orderService.getAllOrders();

      const formattedOrders = response.data.orders.map((o, index) => ({
        sl: index + 1,
        ...o,
        user_name: o.user?.username || "N/A",
        city: o.order_address?.city || "N/A",
        product_qty: o.product_qty || 0,

        created_at: o.created_at,

        order_date: new Date(o.created_at).toLocaleString("en-GB", {
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        }),
      }));

      setOrders(formattedOrders);
    } catch (error) {
      console.error("Error fetching all orders:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleEdit = (row) => {
    navigate(`/admin/order/${row.id}`);
  };

  const handleDelete = () => {};

  return (
    <DashboardWrapper>
      <div
        className="container-fluid"
        style={{
          marginTop: "10px",
          paddingTop: "0",
          paddingBottom: "0",
        }}
      >
        {/* TOP ROW */}
        <div
          className="d-flex justify-content-between align-items-center"
          style={{
            marginBottom: "8px",
            padding: "0 4px",
          }}
        >
          {/* Page Title - LEFT */}
          <h4
            className="mb-0"
            style={{
              fontSize: "20px",
              fontWeight: "500",
              color: "#374151",
            }}
          >
            All Orders
          </h4>

          {/* Breadcrumb - RIGHT */}
          <div style={{ margin: 0 }}>
            <Breadcrumb />
          </div>
        </div>

        {/* TABLE CARD */}
        <div
          className="card shadow"
          style={{
            marginTop: "0",
            marginBottom: "10px",
          }}
        >
          {/* CARD HEADER */}
          <div
            className="card-header"
            style={{
              padding: "8px 16px",
              minHeight: "45px",
            }}
          >
            {/* Keep header compact */}
          </div>

          {/* TABLE BODY */}
          <div
            className="card-body"
            style={{
              padding: "8px 16px 10px",
            }}
          >
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  minHeight: "150px",
                }}
              >
                <Loader />
              </div>
            ) : (
              <CrudTable
                data={orders}
                onEdit={handleEdit}
                onDelete={handleDelete}
                columns={columns}
              />
            )}
          </div>
        </div>
      </div>
    </DashboardWrapper>
  );
}